module.exports = require("@bechtel/client-assets/dist/images/steel-icon.svg");